__turbopack_context__.v({
  "image-container": "style-module-scss-module__gyv3VG__image-container",
  "quote-text": "style-module-scss-module__gyv3VG__quote-text",
});
